/* STADTHOLZ Kategorieseite: Filter als Bottom-Sheet-Dialog (mobil), Auto-Absenden (Desktop),
   Live-Trefferzahl im Dialog. Progressive Verbesserung: Ohne JS funktioniert alles per
   GET-Formular und CSS :target. Kein Framework. */
(function () {
  'use strict';

  var mqMobil = window.matchMedia('(max-width: 749px)');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])';

  function paramsFromForm(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return params;
  }

  /* Leere Felder (z. B. Preis) nicht in die URL schreiben */
  function submitClean(form) {
    var action = form.getAttribute('action') || window.location.pathname;
    var qs = paramsFromForm(form).toString();
    window.location.assign(action + (qs ? '?' + qs : ''));
  }

  function syncTop(root) {
    var header = document.querySelector('[data-sz-header]');
    if (!header) return;
    var wrapper = header.closest('.shopify-section') || header;
    var announce = wrapper.querySelector('.sz-announce');
    var h = wrapper.offsetHeight - (announce ? announce.offsetHeight : 0);
    if (h > 0) root.style.setProperty('--sz-col-top', h + 'px');
  }

  function init(root) {
    if (root.__szInit) return;
    root.__szInit = true;
    root.classList.add('is-js');

    var sectionId = root.getAttribute('data-section-id');
    var sheet = root.querySelector('[data-sz-sheet]');
    var form = root.querySelector('[data-sz-facets]');
    var applyLabel = root.querySelector('[data-sz-apply-label]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-sz-open]'));
    var lastTrigger = null;
    var controller = null;
    var timer = null;

    syncTop(root);
    window.addEventListener('resize', function () { syncTop(root); }, { passive: true });

    /* Sortier-Auswahl: sofort absenden (aktive Filter liegen als hidden inputs im selben Formular) */
    Array.prototype.forEach.call(root.querySelectorAll('[data-sz-autosubmit]'), function (select) {
      select.addEventListener('change', function () {
        if (select.form) submitClean(select.form);
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('form[data-sz-sortform], form[data-sz-facets]'), function (f) {
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        submitClean(f);
      });
    });

    function isOpen() {
      return !!sheet && sheet.classList.contains('is-open');
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (isOpen()) {
          scheduleCount();
          return;
        }
        var t = e.target;
        if (!mqMobil.matches && t && t.name && t.name !== 'sort_by') submitClean(form);
      });
    }

    function setApplyLabel(n) {
      if (!applyLabel) return;
      applyLabel.textContent = n === 1 ? '1 Ergebnis anzeigen' : n + ' Ergebnisse anzeigen';
    }

    function scheduleCount() {
      clearTimeout(timer);
      timer = setTimeout(fetchCount, 250);
    }

    /* Trefferzahl + Zahlen je Option über die Section Rendering API holen */
    function fetchCount() {
      if (!form || !sectionId || !window.fetch || !window.DOMParser) return;
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      var params = paramsFromForm(form);
      params.delete('sort_by');
      params.set('section_id', sectionId);
      var url = (form.getAttribute('action') || window.location.pathname) + '?' + params.toString();
      if (applyLabel) applyLabel.parentNode.setAttribute('aria-busy', 'true');

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var results = doc.querySelector('[data-sz-results]');
          if (results) setApplyLabel(parseInt(results.getAttribute('data-count'), 10) || 0);
          Array.prototype.forEach.call(form.querySelectorAll('[data-sz-count-for]'), function (el) {
            var id = el.getAttribute('data-sz-count-for');
            var neu = doc.querySelector('[data-sz-count-for="' + id + '"]');
            if (neu) el.textContent = neu.textContent;
            var input = document.getElementById(id);
            var neuInput = doc.getElementById(id);
            if (input && neuInput && !input.checked) {
              input.disabled = neuInput.disabled;
              var opt = input.closest('.sz-col__opt');
              if (opt) opt.classList.toggle('is-disabled', neuInput.disabled);
            }
          });
        })
        .catch(function () { /* Zahl bleibt stehen; Absenden funktioniert trotzdem */ })
        .then(function () {
          if (applyLabel) applyLabel.parentNode.removeAttribute('aria-busy');
        });
    }

    function visibleFocusables() {
      return Array.prototype.slice.call(sheet.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetWidth > 0 || el.offsetHeight > 0;
      });
    }

    function onKeydown(e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        e.preventDefault();
        closeSheet(true);
        return;
      }
      if (e.key !== 'Tab') return;
      var items = visibleFocusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (!sheet.contains(document.activeElement)) {
        e.preventDefault();
        first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openSheet(trigger, ziel) {
      if (!sheet) return;
      if (!mqMobil.matches) {
        /* Desktop: Seitenleiste ist sichtbar, Fokus dorthin */
        var firstDesk = visibleFocusables()[0];
        if (firstDesk) firstDesk.focus();
        return;
      }
      lastTrigger = trigger;
      sheet.classList.add('is-open');
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-modal', 'true');
      document.documentElement.classList.add('sz-noscroll');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
      document.addEventListener('keydown', onKeydown);

      var target = null;
      if (ziel === 'sort') {
        var sortset = sheet.querySelector('[data-sz-sortset]');
        if (sortset) {
          sortset.scrollIntoView({ block: 'start' });
          target = sortset.querySelector('input:checked') || sortset.querySelector('input');
        }
      }
      if (!target) target = sheet.querySelector('[data-sz-close-btn]') || visibleFocusables()[0];
      if (target) target.focus();
      fetchCount();
    }

    function closeSheet(returnFocus) {
      if (!isOpen()) return;
      sheet.classList.remove('is-open');
      sheet.removeAttribute('role');
      sheet.removeAttribute('aria-modal');
      document.documentElement.classList.remove('sz-noscroll');
      openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
      document.removeEventListener('keydown', onKeydown);
      if (returnFocus && lastTrigger) lastTrigger.focus();
    }

    openers.forEach(function (o) {
      o.setAttribute('role', 'button');
      o.setAttribute('aria-expanded', 'false');
      o.addEventListener('click', function (e) {
        e.preventDefault();
        openSheet(o, o.getAttribute('data-sz-open'));
      });
      o.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          openSheet(o, o.getAttribute('data-sz-open'));
        }
      });
    });

    Array.prototype.forEach.call(root.querySelectorAll('[data-sz-close]'), function (c) {
      if (c.tagName === 'A') c.setAttribute('role', 'button');
      c.addEventListener('click', function (e) {
        e.preventDefault();
        closeSheet(true);
      });
    });

    /* „Zurücksetzen“ im Dialog: Auswahl leeren, Sortierung behalten, nicht neu laden */
    Array.prototype.forEach.call(root.querySelectorAll('[data-sz-reset]'), function (btn) {
      btn.addEventListener('click', function (e) {
        if (!form || !isOpen()) return;
        e.preventDefault();
        Array.prototype.forEach.call(form.querySelectorAll('input[type="checkbox"]'), function (i) { i.checked = false; });
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (i) { i.value = ''; });
        fetchCount();
      });
    });

    function onMq() {
      if (!mqMobil.matches) closeSheet(false);
    }
    if (mqMobil.addEventListener) mqMobil.addEventListener('change', onMq);
    else if (mqMobil.addListener) mqMobil.addListener(onMq);
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-sz-collection]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('sz-noscroll');
  });
})();
